import React from "react";
import ReactDOM from "react-dom";
import { BrowserRouter as Router } from "react-router-dom";
import { Provider } from "react-redux";
import { createStore } from "redux";
import rootReducer from "./state/reducers";
import "./stylings/index.scss";
import "@progress/kendo-theme-default/dist/all.css";
import "antd/dist/antd.min.css";
import App from "./App";

// Suppress ResizeObserver errors (common with rich text editors)
const resizeObserverLoopErr = (e) => {
    if (
        e.message ===
            "ResizeObserver loop completed with undelivered notifications." ||
        e.message === "ResizeObserver loop limit exceeded"
    ) {
        const resizeObserverErrDiv = document.getElementById(
            "webpack-dev-server-client-overlay-div",
        );
        const resizeObserverErr = document.getElementById(
            "webpack-dev-server-client-overlay",
        );
        if (resizeObserverErr) {
            resizeObserverErr.setAttribute("style", "display: none");
        }
        if (resizeObserverErrDiv) {
            resizeObserverErrDiv.setAttribute("style", "display: none");
        }
    }
};
window.addEventListener("error", resizeObserverLoopErr);

export const store = createStore(rootReducer);
// const subscriber = () =>
//     console.log("SUBSCRIBE, ", store.getState().dataReducer);
// store.subscribe(subscriber);

ReactDOM.render(
    <Provider store={store}>
        <Router>
            <App />
        </Router>
    </Provider>,
    document.getElementById("root"),
);
